import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { BACKEND_URL } from "../Helpers/constant";

export const getAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req: AxiosRequestConfig): any => {
    req.headers = req.headers || {};
    return req;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export let axiosInstance: AxiosInstance = getAxiosInstance();

export const verifyLogin = async (payload: object) => {
  const res: any = await axiosInstance.post(`/v1/auction-auth/login`, payload);
  return res;
};

export const getPlayersDetails = async () => {
  const res = await axiosInstance.get(`v1/auction/get-all-players`);
  return res;
};

export const getTeamDetails = async () => {
  const res = await axiosInstance.get(`v1/auction/teams`);
  return res;
};

export const getAuctionWindow = async () => {
  const res = await axiosInstance.get(`v1/auction/auction-window`);
  return res;
};

export const updateAuctionWindow = async (
  windowId: string,
  payload: {
    Auction_Start_Date_Time__c: string;
    Auction_End_Date_Time__c: string;
  },
) => {
  const path = `/v1/auction/auction-window/${windowId}`;
  try {
    if (typeof window !== "undefined") {
      const sameOriginRes = await axios.patch(path, payload, {
        headers: { "Content-Type": "application/json" },
        timeout: 15000,
      });
      return sameOriginRes;
    }
  } catch (error) {
    // Fallback below for non-proxied environments.
  }

  const res = await axiosInstance.patch(path, payload);
  return res;
};


export const updatePlayerDetails = async (
  recordId: string,
  updatePayload: any
) => {
  try {
    const path = `/v1/auction/player/${recordId}`;
    const res: any = await axiosInstance.patch(path, updatePayload);
    return res;
  } catch (error) {
    return error;
  }
};

export const postContactUsForm = async (payload: any) => {
  try {
    const path = `/v1/application/contactUs`;
    const res: any = await axiosInstance.post(path, payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const createStaffContact = async (data: any) => {
  try {
    const path = `/v1/staff-application/create/staff-contact`;
    const res: any = await axiosInstance.post(path, data);
    return res;
  } catch (error) {
    return error;
  }
};

export const updateStaffContact = async (contactId: string, data: any) => {
  try {
    const path = `/v1/staff-application/update/staff-contact/${contactId}`;
    const res: any = await axiosInstance.patch(path, data);
    return res;
  } catch (error) {
    return error;
  }
};

export const getStaffContactDetails = (contactId: string) => {
  const res = axiosInstance.get(
    `/v1/staff-application/contact/details/${contactId}`
  );
  return res;
};

export const updateContactDetails = (mcaNo: string, data: object) => {
  const res = axiosInstance.put(
    `/v1/staff-application/contact/update/${mcaNo}`,
    data
  );
  return res;
};

export const getExpertise = () => {
  const res = axiosInstance.get(`/v1/staff-application/get-expertise`);
  return res;
};

export const getStaffAplicationDetails = (contactId: string) => {
  const res = axiosInstance.get(
    `/v1/staff-application/expertise/details/${contactId}`
  );
  return res;
};

export const postStaffRegestration = (data: object) => {
  const res = axiosInstance.post(
    `/v1/staff-application/staff-registration`,
    data
  );
  return res;
};

export const updateStaffRegDetails = (staffRegId: any, data: object) => {
  const res = axiosInstance.put(
    `/v1/staff-application/staff-registration/update/${staffRegId}`,
    data
  );
  return res;
};

// other

export const getPlayerRegestrationWindow = () => {
  const res = axiosInstance.get(`/v1/application/player-registration-window`);
  return res;
};

export const verifyMCANumber = async (mcaNo: string) => {
  const res: AxiosResponse = await axiosInstance.get(
    `/v1/application/account/mca/${mcaNo}`
  );

  return res;
};

export const getPlayerRegDetails = (playerId: any) => {
  const res = axiosInstance.get(
    `/v1/application/player-registration/details/${playerId}`
  );
  return res;
};

export const updatePlayerRegDetails = (regId: any, data: object) => {
  const res = axiosInstance.put(
    `/v1/application/player-registration/update/${regId}`,
    data
  );
  return res;
};

export const postPlayerRegestration = (data: object) => {
  const res = axiosInstance.post(`/v1/application/player-registration`, data);
  return res;
};

export const getFileUrl = async (data: File) => {
  try {
    const path = `/v1/application/create/publicUrl`;
    const form = new FormData();
    form.append("file", data);
    const res: any = await axiosInstance.post(path, form);
    return res;
  } catch (error) {
    return error;
  }
};
